import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-session-expired-modal',
  template: `
    <div class="modal-body text-center p-4">
      <div class="expired-icon" aria-hidden="true"><i class="fa-solid fa-clock-rotate-left"></i></div>
      <h5 class="mb-2">Session expired</h5>
      <p class="text-body-secondary mb-0">Your session has ended for security reasons. Please sign in again to continue.</p>
    </div>
    <div class="modal-footer border-0 pt-0 justify-content-center">
      <button type="button" class="btn btn-primary px-4" (click)="active.close()" ngbAutofocus>Sign in again</button>
    </div>
  `,
  styles: `
    .expired-icon {
      width: 56px;
      height: 56px;
      margin: 0 auto 1rem;
      display: grid;
      place-items: center;
      border-radius: 50%;
      background: var(--bs-warning-bg-subtle);
      color: var(--bs-warning-text-emphasis);
      font-size: 1.35rem;
    }
  `,
})
export class SessionExpiredModal {
  protected readonly active = inject(NgbActiveModal);
}
